<script setup lang="ts">
import { ref } from 'vue';
import { useElementSize } from '@vueuse/core';
import { Icon } from '@/components/ui';
import { cn } from '@/lib/utils';
import type { MarketColors } from '@/types';

const el = ref(null);
const { width } = useElementSize(el);

interface Props {
  color?: MarketColors[number] | 'primary';
  as?: string;
}

withDefaults(defineProps<Props>(), {
  as: 'button',
  color: 'primary',
});
</script>

<template>
  <component
    :is="as"
    :style="`--filler-50: var(--${color})`"
    :class="
      cn(
        'group isolate inline-flex h-[3em] items-center gap-2 overflow-hidden whitespace-nowrap rounded-[2px] rounded-br-xl font-sans-ui text-sm font-bold tracking-wider text-filler-50 transition-colors duration-100 hover:bg-filler-50 hover:text-white focus:bg-filler-50 focus:text-white disabled:pointer-events-none disabled:opacity-50',
        $attrs.class ?? '',
      )
    "
  >
    <div class="flex items-center justify-center transition-transform">
      <div
        ref="el"
        class="z-poi-pins flex h-full items-center justify-center bg-transparent px-3 transition-transform duration-300 group-hover:translate-x-[2.25em] group-focus:translate-x-[2.25em]"
      >
        <slot />
      </div>
      <div
        class="flex aspect-square size-[3em] items-center justify-center bg-filler-50 text-white transition-transform duration-300 ease-out"
        :style="`--tw-translate-x: -${width + 24}px`"
        :class="`group-hover:-translate-x-0 group-focus:-translate-x-0`"
      >
        <slot name="icon">
          <Icon class="size-[0.75em]" name="chevron-right" />
        </slot>
      </div>
    </div>
  </component>
</template>
